import DeleteProductImage from './DeleteProductImage/DeleteProductImage';
import UploadProductImage from './UploadProductImage/UploadProductImage';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import docs from '../../../../config/docs';
import { Info } from '@material-ui/icons';
import React, { Component } from 'react';
import { IconButton } from 'material-ui';
const URL = docs.docsImages;

class ProductImages extends Component {

	constructor(props) {
		super(props);
		this.state = {
			tabIndex: 0
		}
	}

	redirectTo() {
		const newWindow = window.open(URL, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	render() {
		return (
			<div className="main-content">
				<div className="malls-category-headers">
					Gestión de imágenes
					<IconButton
						size="small"
					>
						<Info onClick={() => this.redirectTo()} />
					</IconButton>
				</div>
				<div className="user-category-wrapper">
					<Tabs
						style={{ width: "100%" }}
						selectedIndex={this.state.tabIndex}
						onSelect={tabIndex => this.setState({ tabIndex })}
						default={true}
					>
						<TabList >
							<Tab>Carga masiva de Imágenes</Tab>
							<Tab>Eliminar imágenes</Tab>
						</TabList>
						<center>
							<TabPanel>
								<UploadProductImage />
							</TabPanel>
							<TabPanel>
								<DeleteProductImage />
							</TabPanel>
						</center>
					</Tabs>
				</div>
			</div>
		);
	}
}


export default ProductImages